import { HelixBackdrop } from "../BrandBackdrop";
import { Skeleton } from "../ui/skeleton";
import { AssetCardSkeleton } from "./AssetCardSkeleton";

export const FeaturedAssetSkeleton = () => (
  <div className="rounded-3xl overflow-hidden bg-card border border-white/[0.07]">
    <div className="grid lg:grid-cols-2 gap-0">
      <div className="relative aspect-[4/3] lg:aspect-auto lg:min-h-[500px]">
        <Skeleton className="absolute inset-0 rounded-none" />
        <div className="absolute left-4 top-4 flex gap-3">
          <Skeleton className="h-8 w-24 rounded-full" />
          <Skeleton className="h-8 w-20 rounded-full" />
        </div>
      </div>
      <div className="p-6 lg:p-8 flex flex-col justify-center">
        <Skeleton className="h-4 w-40 mb-3" />
        <Skeleton className="h-8 w-3/4 mb-6" />
        <div className="grid grid-cols-2 gap-4 mb-6">
          {[0, 1, 2, 3].map((key) => (
            <div key={key} className="p-4 rounded-xl bg-muted/50 border border-white/[0.07] space-y-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-7 w-24" />
            </div>
          ))}
        </div>
        <div className="mb-6 space-y-2">
          <div className="flex justify-between">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-12" />
          </div>
          <Skeleton className="h-3 w-full rounded-full" />
          <div className="flex justify-between">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
        <Skeleton className="h-12 w-full rounded-xl" />
      </div>
    </div>
  </div>
);

export const PrimaryMarketplaceSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading marketplace"
    >
      {/* Hero */}
      <div className="vestn-nav-opening mb-8" style={{ minHeight: '28rem' }}>
        <HelixBackdrop opening />
        <div className="container mx-auto px-4 lg:px-8 relative z-10 mb-4">
          <Skeleton className="h-4 w-36" />
        </div>
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <Skeleton className="h-8 w-48 rounded-full mb-4" />
              <Skeleton className="h-12 w-80 mb-2" />
              <Skeleton className="h-12 w-56 mb-4" />
              <Skeleton className="h-5 w-full max-w-xl mb-2" />
              <Skeleton className="h-5 w-2/3 max-w-md" />
            </div>
            <div className="flex items-center gap-3">
              <div className="p-4 rounded-xl bg-card/50 border border-white/[0.07] text-center min-w-[120px]">
                <Skeleton className="h-8 w-10 mx-auto mb-2" />
                <p className="text-sm text-muted-foreground">Sample Assets</p>
              </div>
              <div className="p-4 rounded-xl bg-card/50 border border-white/[0.07] text-center min-w-[120px]">
                <Skeleton className="h-8 w-12 mx-auto mb-2" />
                <p className="text-sm text-muted-foreground">Sample Avg. Target IRR</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 pb-8">
        <div className="flex flex-col lg:flex-row gap-4 mb-6">
          <Skeleton className="h-12 flex-1 rounded-xl" />
          <div className="flex gap-3">
            <Skeleton className="h-12 w-40 rounded-2xl" />
            <Skeleton className="h-12 w-24 rounded-2xl" />
            <Skeleton className="h-12 w-[88px] rounded-xl" />
          </div>
        </div>

        <div className="mb-4">
          <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary" />
            Featured Investment
          </h2>
        </div>
        <div className="mb-12">
          <FeaturedAssetSkeleton />
        </div>

        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-foreground flex items-center gap-3">
            All Investments
            <Skeleton className="h-7 w-24 rounded-full" />
          </h2>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <AssetCardSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const MarketplaceLoadMoreSkeleton = () => (
  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 mt-6">
    {Array.from({ length: 4 }).map((_, index) => (
      <AssetCardSkeleton key={index} />
    ))}
  </div>
);
